module.exports = __webpack_public_path__ + "static/media/welcome-profile.0562fa04.png";